import React, { useEffect, useMemo, useState } from 'react';
import '../../styles/Home.css';
import {
    FaTwitter,
    FaFacebook,
    FaLinkedin,
    FaYoutube,
    FaChevronCircleRight,
    FaArrowRight,
    FaUser,
    FaPen,
} from 'react-icons/fa';
import moment from 'moment';
import { BASE_URL } from '../../settings';
import { Navbar } from 'responsive-navbar-react';
import 'responsive-navbar-react/dist/index.css';
import { Routes, Route, useNavigate } from 'react-router-dom';

// 👇️pages
import AboutUs from '../About/AboutUs';
import AlumniSection from '../Alumni/AlumniSection';
import Gallery from '../Gallery/Gallery';
import ClassAlumniProfiles from '../Alumni/ClassAlumniProfiles';
import LoggedInAlumniProfile from '../Alumni/LoggedInAlumniProfile';
import Alumni_Inbox from '../Alumni_Messaging/Alumni_Inbox';
import Alumni_ChatArea from '../Alumni_Messaging/Alumni_ChatArea';
import InfoBoard from '../InfoBoard/InfoBoard';
import EventDetail from '../InfoBoard/EventDetail';
import AnnouncementDetail from '../InfoBoard/AnnouncementDetail';
import Account from '../Alumni_Account/Account';
import JobPostDetail from '../InfoBoard/JobPostDetail';

var user_uuid;

export const get_alumni_uuid = () => user_uuid;

export default function Home({
    events,
    fetchEvents,
    announcements,
    jobPostings,
    alumni,
    photos,
    eventsError,
    announcementsError,
    jobPostsError,
    alumniError,
    alumniData,
}) {
    const [pageAtTop, setPageAtTop] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        user_uuid = alumniData?.uuid;
    }, []);

    // props for the nav bar
    const props = {
        items: [
            {
                text: 'Home',
                link: '/',
            },
            {
                text: 'Info Board',
                link: '/info',
            },
            {
                text: 'Alumni Section',
                link: '/alumni',
            },
            {
                text: 'About Us',
                link: '/about',
            },
            {
                text: 'Gallery',
                link: '/gallery',
            },
            {
                text: alumniData?.email ? (
                    <span
                        className='navbar-alumni-email-intial'
                        onClick={() =>
                            navigate(`/alumni/classes/${alumniData?.classYear}/${alumniData?.uuid}`)
                        }
                    >
                        {alumniData?.email?.charAt(0)?.toUpperCase()}
                    </span>
                ) : (
                    <span
                        onClick={() =>
                            navigate(`/alumni/classes/${alumniData?.classYear}/${alumniData?.uuid}`)
                        }
                        className='navbar-alumni-email-intial'
                    >
                        {<FaUser size={15} />}
                    </span>
                ),
            },
        ],
        logo: {
            text: (
                <img
                    src={require('../../images/logo.png')}
                    style={{
                        backgroundColor: 'white',
                        padding: 8,
                        borderRadius: 10,
                        margin: 0,
                    }}
                    alt='logo'
                />
            ),
            link: '/',
        },
        style: {
            barStyles: {
                background: 'darkblue',
                paddingTop: 10,
                paddingBottom: 10,
                zIndex: 100000000,
                boxShadow: pageAtTop ? 'none' : '5px 5px 35px #000',
                transition: 'all .25 ease-out',
            },
            sidebarStyles: {
                background: '#222',
                buttonColor: 'white',
            },
        },
        // float: true,
    };

    return (
        <>
            {/* Nav Bar section  */}
            <Navbar {...props} />
            <Routes>
                <Route
                    exact
                    path='/'
                    element={
                        <Home_layout
                            events={events}
                            announcements={announcements}
                            alumni={alumni}
                            jobPostings={jobPostings}
                            photos={photos}
                            eventsError={eventsError}
                            announcementsError={announcementsError}
                            jobPostsError={jobPostsError}
                            alumniError={alumniError}
                        />
                    }
                >
                    {' '}
                </Route>

                <Route
                    exact
                    path='/alumni'
                    element={
                        <AlumniSection
                            allAlumni={alumni?.filter((item) => item?.uuid != alumniData?.uuid)}
                        />
                    }
                >
                    {' '}
                </Route>

                <Route exact path='/alumni/classes/:year' element={<ClassAlumniProfiles />}>
                    {' '}
                </Route>

                <Route
                    exact
                    path='/alumni/classes/:year/:id'
                    element={
                        <LoggedInAlumniProfile
                            // alumniData={{
                            //     id: 8,
                            //     uuid: 'bbffff6c-1045-4f0f-8d18-ec2877b6bfaa',
                            //     username: 'Kayzman',
                            //     email: 'ngonik8@gmail.com',
                            //     firstName: 'Ngoni',
                            //     lastName: 'Katsidzira',
                            //     githubLink: 'https://www.github.com',
                            //     linkedInLink: null,
                            //     facebookLink: 'https://www.facebook.com/ngonikay50',
                            //     twitterLink: 'https://www.twitter.com/Kayzman11',
                            //     about: "Hie there 👋, I'm a mobile, api and backend developer.",
                            //     avatar: 'me.png',
                            //     classYear: '2023',
                            //     positionName: 'A Freelancer',
                            //     suspended: false,
                            //     createdAt: '2023-04-26T20:05:26.000Z',
                            //     updatedAt: '2023-04-26T20:08:55.000Z',
                            // }}
                            alumniData={alumniData}
                            fetchEvents={fetchEvents}
                        />
                    }
                >
                    {' '}
                </Route>

                <Route exact path='/alumni/inbox/:id' element={<Alumni_Inbox />}>
                    {' '}
                </Route>

                <Route exact path='/alumni/chat/:id' element={<Alumni_ChatArea />}>
                    {' '}
                </Route>

                <Route
                    exact
                    path='/info'
                    element={
                        <InfoBoard
                            events={events}
                            announcements={announcements}
                            jobPostings={jobPostings}
                            // alumniData={{
                            //     id: 8,
                            //     uuid: 'bbffff6c-1045-4f0f-8d18-ec2877b6bfaa',
                            //     username: 'Kayzman',
                            //     email: 'ngonik8@gmail.com',
                            //     firstName: 'Ngoni',
                            //     lastName: 'Katsidzira',
                            //     githubLink: 'https://www.github.com',
                            //     linkedInLink: null,
                            //     facebookLink: 'https://www.facebook.com/ngonikay50',
                            //     twitterLink: 'https://www.twitter.com/Kayzman11',
                            //     about: "Hie there 👋, I'm a mobile, api and backend developer.",
                            //     avatar: 'me.png',
                            //     classYear: '2023',
                            //     positionName: 'A Freelancer',
                            //     suspended: false,
                            //     createdAt: '2023-04-26T20:05:26.000Z',
                            //     updatedAt: '2023-04-26T20:08:55.000Z',
                            // }}
                            alumniData={alumniData}
                            fetchEvents={fetchEvents}
                        />
                    }
                >
                    {' '}
                </Route>

                <Route
                    exact
                    path='/info/eventDetail/:uuid'
                    element={<EventDetail fetchEvents={fetchEvents} alumniData={alumniData} />}
                >
                    {' '}
                </Route>

                <Route exact path='/info/announcementDetail/:uuid' element={<AnnouncementDetail />}>
                    {' '}
                </Route>

                <Route
                    exact
                    path='/jobpostDetail/:uuid'
                    element={<JobPostDetail alumniData={alumniData} />}
                >
                    {' '}
                </Route>

                <Route exact path='/about' element={<AboutUs />}>
                    {' '}
                </Route>

                <Route exact path='/gallery' element={<Gallery />}>
                    {' '}
                </Route>

                <Route
                    exact
                    path='/login'
                    element={
                        <Home_layout
                            events={events}
                            announcements={announcements}
                            alumni={alumni}
                            jobPostings={jobPostings}
                            photos={photos}
                            eventsError={eventsError}
                            announcementsError={announcementsError}
                            jobPostsError={jobPostsError}
                            alumniError={alumniError}
                        />
                    }
                >
                    {' '}
                </Route>
            </Routes>
        </>
    );
}

const Home_layout = ({
    events,
    announcements,
    alumni,
    jobPostings,
    photos,
    eventsError,
    announcementsError,
    jobPostsError,
    alumniError,
}) => {
    const { clientWidth } = document.body;
    const navigate = useNavigate();
    const [alumniData, setAlumniData] = useState();
    const [isViewingImages, setIsViewingImages] = useState(true);

    // 👇️ handler to filter our overdue events
    const filterOverdueEvents = () => {
        let notOverdue = events?.filter(
            (item) => new Date(item?.startDate).getTime() >= new Date().getTime()
        );
        return notOverdue?.slice(0, 6);
    };

    let filterd_jobPostings = jobPostings?.filter(
        (item) => new Date(item?.dueDate).getDate() >= new Date().getDate()
    );

    return (
        <div className='home'>
            <div className='home-content-container'>
                {/* header section */}
                <div className='home-header-container'>
                    <h1>HIT </h1>
                    <h1 className='branded'>Alumni</h1>
                    <span>Success through innovation.</span>
                    {/* <hr /> */}
                </div>

                {/* gallery section */}
                <div className='home-gallery-header' onClick={() => navigate('/gallery')}>
                    <h1>Gallery {<FaArrowRight size={25} />}</h1>
                </div>

                <div className='home-gallery-section'>
                    <div className='home-gallery-section-images'>
                        {photos.map((image, index) => (
                            <div
                                onClick={() => setIsViewingImages(!isViewingImages)}
                                key={`image#${index}`}
                                className='home-gallery-image-container'
                            >
                                <img src={image?.mainUrl} id='slider' />
                            </div>
                        ))}
                    </div>

                    <FaArrowRight size={40} color='darkblue' />
                </div>

                {/* upcoming events section */}
                <div className='upcoming-events'>
                    <div className='upcoming-events-header' onClick={() => navigate(`/info`)}>
                        <div className='left'>
                            <h1>Upcoming events</h1>
                            <span>📆</span>
                        </div>
                    </div>

                    <div className='upcoming-events-items'>
                        {filterOverdueEvents()?.length > 0 ? (
                            filterOverdueEvents()?.map((item, index) => (
                                <div
                                    className='upcoming-event-item'
                                    key={`item-${item?.id}-${index}`}
                                    onClick={() => navigate(`/info/eventDetail/${item?.uuid}`)}
                                >
                                    <div className='left'>
                                        <span
                                            className='upcoming-event-color'
                                            style={{ backgroundColor: item?.color }}
                                        ></span>

                                        <div className='upcoming-event-detail'>
                                            <span className='upcoming-event-title'>
                                                {item?.name || 'Event'}
                                            </span>
                                            <span className='upcoming-event-date'>
                                                Coming up{' '}
                                                {/* {moment(
                                                    new Date(item?.startDate).toISOString()
                                                ).fromNow()} */}
                                                {moment(
                                                    new Date(item?.startDate).toISOString()
                                                ).calendar()}
                                            </span>
                                        </div>
                                    </div>

                                    <FaChevronCircleRight size={20} />
                                </div>
                            ))
                        ) : (
                            <div className='empty-upcoming-events-container'>
                                {eventsError ? (
                                    <h1
                                        className='empty-upcoming-events-text'
                                        style={{ color: 'orangered' }}
                                    >
                                        {eventsError}
                                    </h1>
                                ) : (
                                    <h1 className='empty-upcoming-events-text'>
                                        No upcoming events yet...
                                    </h1>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* announcements section */}
                <div className='upcoming-events'>
                    <div className='upcoming-events-header' onClick={() => navigate('/info')}>
                        <div className='left'>
                            <h1>Announcements</h1>
                            <span>📢</span>
                        </div>
                    </div>

                    <div className='upcoming-events-items'>
                        {announcements?.length > 0 ? (
                            announcements?.slice(0, 4)?.map((item, index) => (
                                <div
                                    className='upcoming-event-item'
                                    key={`item-${item?.id}-${index}`}
                                >
                                    <div className='left'>
                                        <span
                                            className='upcoming-event-color'
                                            style={{ backgroundColor: 'gold' }}
                                        ></span>

                                        <div className='upcoming-event-detail'>
                                            <span className='upcoming-event-title'>
                                                {item?.title || 'Announcement'}
                                            </span>
                                            <span className='upcoming-event-date'>
                                                Announced:{' '}
                                                {moment(
                                                    new Date(item?.createdAt).toISOString()
                                                ).calendar()}
                                            </span>
                                        </div>
                                    </div>

                                    <FaChevronCircleRight size={20} />
                                </div>
                            ))
                        ) : (
                            <div className='empty-upcoming-events-container'>
                                {announcementsError ? (
                                    <h1
                                        className='empty-upcoming-events-text'
                                        style={{ color: 'orangered' }}
                                    >
                                        {announcementsError}
                                    </h1>
                                ) : (
                                    <h1 className='empty-upcoming-events-text'>
                                        No Announcements events yet...
                                    </h1>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* job postings section */}
                <div className='upcoming-events'>
                    <div className='upcoming-events-header' onClick={() => navigate('/info')}>
                        <h1>Job Postings</h1>
                        <span>🏢</span>
                    </div>

                    <div className='upcoming-events-items'>
                        {filterd_jobPostings?.length > 0 ? (
                            filterd_jobPostings.map((item, index) => (
                                <div
                                    className='upcoming-event-item'
                                    key={`item-${item?.id}-${index}`}
                                >
                                    <div className='left'>
                                        <span
                                            className='upcoming-event-color'
                                            style={{ backgroundColor: 'darkblue' }}
                                        ></span>

                                        <div className='upcoming-event-detail'>
                                            <span className='upcoming-event-title'>
                                                {item?.companyName || 'Job Post'}
                                            </span>
                                            <span className='upcoming-event-date'>
                                                Required Position: {item?.positionName}
                                            </span>
                                            <span className='upcoming-event-date'>
                                                Closes on{' '}
                                                {/* {moment(new Date(item?.from).toISOString()).fromNow()} */}
                                                {moment(
                                                    new Date(item?.dueDate).toISOString()
                                                ).calendar()}
                                                {/* {item?.dueDate} */}
                                            </span>
                                        </div>
                                    </div>

                                    <FaChevronCircleRight size={20} />
                                </div>
                            ))
                        ) : (
                            <div className='empty-upcoming-events-container'>
                                {jobPostsError ? (
                                    <h1
                                        className='empty-upcoming-events-text'
                                        style={{ color: 'orangered' }}
                                    >
                                        {jobPostsError}
                                    </h1>
                                ) : (
                                    <h1 className='empty-upcoming-events-text'>
                                        No Job postings yet...
                                    </h1>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* alumni section */}
                <div className='home-alumni-section'>
                    <div className='home-alumni-section-header' onClick={() => navigate('/alumni')}>
                        <h1>Some of our Alumni</h1>
                        <span>🧑‍🎓</span>
                    </div>

                    <div className='home-alumni-items'>
                        {alumni?.length > 0 ? (
                            alumni?.slice(0, 4)?.map((item, index) => {
                                return (
                                    <div
                                        className='home-alumni-item'
                                        key={`item-${index}-${item.id}`}
                                        onClick={() =>
                                            navigate(
                                                `/alumni/classes/${item?.classYear}/${item?.uuid}`
                                            )
                                        }
                                    >
                                        <div className='left'>
                                            <div className='home-alumni-item-profile-pic-container'>
                                                <img
                                                    src={
                                                        item?.avatar
                                                            ? `${BASE_URL}/alumni/uploads/get-profile-pic/${item?.avatar}`
                                                            : require('../../images/profile-pictures/face1.jpg')
                                                    }
                                                    alt='home-alumni-item-profile-picture'
                                                />
                                            </div>

                                            <div className='home-alumni-item-detail'>
                                                <span className='home-alumni-item-name'>
                                                    {item.firstName +
                                                        ' ' +
                                                        item.lastName?.slice(0, 26)}
                                                </span>
                                                <span className='home-alumni-item-positionName'>
                                                    {item.positionName}
                                                </span>

                                                <span className='home-alumni-item-classYear'>
                                                    Class of {item.classYear}
                                                </span>
                                            </div>
                                        </div>

                                        <FaChevronCircleRight size={20} />
                                    </div>
                                );
                            })
                        ) : (
                            <div className='home-empty-alumni-container'>
                                {alumniError ? (
                                    <h1
                                        className='home-empty-alumni-text'
                                        style={{ color: 'orangered' }}
                                    >
                                        {alumniError}
                                    </h1>
                                ) : (
                                    <h1 className='home-empty-alumni-text'>
                                        No Alumni data yet...
                                    </h1>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className='contact-us'>
                <h1>Contact Us</h1>

                <div className='contact-us-items'>
                    <div className='contact-us-item'>
                        <h1>Postal Address</h1>
                        <span>Harare Institute of Technology</span>
                        <span>P. O. Box BE 277, Belvedere, Harare</span>
                        <span>Zimbabwe</span>
                    </div>

                    <div className='contact-us-item'>
                        <h1>Physical Address</h1>
                        <span>Harare Institute of Technology Campus</span>
                        <span>Ganges Road, Belvedere,</span>
                        <span>Harare</span>
                    </div>

                    <div className='contact-us-item'>
                        <h1>Telephone</h1>
                        <span>+263 242 741 422-36</span>
                    </div>

                    <div className='contact-us-item'>
                        <h1>Official Webiste</h1>
                        <span>
                            <a href='www.hit.ac.zw'>Harare Institute Of Technology</a>
                        </span>
                    </div>

                    <div className='contact-us-item  connect-with-us'>
                        <h1>Connect With Us</h1>
                        <div className='connect-icons'>
                            <span>
                                <FaFacebook
                                    color='white'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                            <span>
                                <FaYoutube
                                    color='red'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                            <span>
                                <FaTwitter
                                    color='white'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                            <span>
                                <FaLinkedin
                                    color='white'
                                    size={clientWidth >= 768 && clientWidth <= 992 ? 30 : 20}
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
